import './src/main.css'
import Decoration12 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration12.name, Decoration12)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration12/index.js